import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { selectSelectedSession } from '../../../domain/selectors/selected/chat/selectSelectedSession';
import { AssistantsChatSession, AssistantType } from '../../../domain/chat/models/ChatSession';
import { ChatProviderType } from '../../../domain/chat/models/ChatProviderType';
import ChatWindow from './ChatWindow';
import EngagementPage from '../../Engagement/components/EngagementPage';

// --------------------------------------------------------------------------
// SessionWindowRouter
//
// Decides which "window" component to render based on the selected session
// type. This keeps ChatWindow and EngagementPage fully decoupled from each
// other and removes the need for conditional logic inside either component.
//
// Ownership rules:
//  - Engagement Assistants sessions -> EngagementPage
//  - All other sessions             -> ChatWindow
// --------------------------------------------------------------------------
const SessionWindowRouter: React.FC = () => {
	const selectedSession = useAppSelector(selectSelectedSession);

	if (
		selectedSession?.providerType === ChatProviderType.Assistants &&
		(selectedSession as AssistantsChatSession).assistantType === AssistantType.Engagement
	) {
		return <EngagementPage />;
	}

	return <ChatWindow />;
};

export default SessionWindowRouter;
